if (window.$('#nd').length) {
    window.$(document).ready(function() {
        if (window.$('.nd__faq__toggle').length) {
            $('.nd__faq__toggle').click(function() {
                $(this)
                    .parent()
                    .find('.nd__faq__answer')
                    .slideToggle();

                $(this)
                    .parent()
                    .toggleClass('nd__faq__item--is-active');
            });
        }

        if (window.$('.nd__order__summary').length) {
            $('.nd__payment__toggle').click(function() {
                if ( $('.nd__input__email').val().length && $('.nd__input__password').val().length && $('.nd__input__name').val().length) {
                    const target = $(this).data('toggle-target');
                    const targetContent = $("[data-content-for='" + target + "']");
                    const targetAction = $("[data-action-for='" + target + "']");
    
                    
                    $('#payment_type').val('');
                    if ($(this).hasClass('paypal')) {
                        $('#payment_type').val('paypal');
                        $('.nd__submit').addClass('nd__hidden');
                    }
                    if ($(this).hasClass('credit_card')) {
                        $('#payment_type').val('credit_card');
                        $('.nd__submit').removeClass('nd__hidden');
                    }

                    $(this)
                        .parent()
                        .parent()
                        .find('.nd__payment__form__item')
                        .removeClass('nd__is-active');

                    $(this)
                        .parent()
                        .toggleClass('nd__is-active');

                    $('.nd__content__toggle')
                        .not(targetContent)
                        .slideUp();
                        
                    $('.nd__order__summary__form__action')
                        .not(targetAction)
                        .slideUp();
                        
                    targetContent.slideDown();
                    targetAction.slideDown();
                }
            });

            $('.nd__reveal__password').click(function() {
                $(this).toggleClass('nd__is-active');
                $(this).hasClass('nd__is-active')
                    ? $(this)
                          .parent()
                          .find('.nd__input__password')
                          .attr('type', 'text')
                    : $(this)
                          .parent()
                          .find('.nd__input__password')
                          .attr('type', 'password');
            });

            $('.nd__addfield').click(function(e) {
                e.preventDefault();

                const target = $(this).attr('data-target');
                $(this)
                    .parent()
                    .addClass('nd__hidden');

                $('[data-id="' + target + '"]').removeClass('nd__hidden');
            });
        }

        if (window.$('.nd__opportunities').length) {
            let path1 = anime.path('#motion path');
            let path2 = anime.path('#motion2 path');
            let path3 = anime.path('#motion3 path');
            let path4 = anime.path('#motion4 path');
            let path5 = anime.path('#motion5 path');
            let path6 = anime.path('#motion6 path');
            let path7 = anime.path('#motion7 path');

            anime({
                targets: '.nd__opportunities__item__avatar--5',
                translateX: path1('x'),
                translateY: path1('y'),
                easing: 'linear',
                duration: 30000,
                loop: true,
            });
            anime({
                targets: '.nd__opportunities__item__avatar--4',
                translateX: path2('x'),
                translateY: path2('y'),
                easing: 'linear',
                duration: 40000,
                loop: true,
                direction: 'reverse',
            });
            anime({
                targets: '.nd__opportunities__item__avatar--3',
                translateX: path3('x'),
                translateY: path3('y'),
                easing: 'linear',
                duration: 40000,
                loop: true,
            });
            anime({
                targets: '.nd__opportunities__item__avatar--2',
                translateX: path4('x'),
                translateY: path4('y'),
                easing: 'linear',
                duration: 35000,
                loop: true,
                direction: 'reverse',
            });
            anime({
                targets: '.nd__opportunities__item__avatar--6',
                translateX: path5('x'),
                translateY: path5('y'),
                easing: 'linear',
                duration: 25000,
                loop: true,
                direction: 'reverse',
            });
            anime({
                targets: '.nd__opportunities__item__screen',
                translateX: path3('x'),
                translateY: path3('y'),
                easing: 'linear',
                duration: 40000,
                loop: true,
                direction: 'reverse',
            });
            anime({
                targets: '.nd__opportunities__item__image--1',
                translateX: path6('x'),
                translateY: path6('y'),
                easing: 'linear',
                duration: 40000,
                loop: true,
            });
            anime({
                targets: '.nd__opportunities__item__logo--1',
                translateX: path6('x'),
                translateY: path6('y'),
                easing: 'linear',
                duration: 40000,
                loop: true,
            });
            anime({
                targets: '.nd__opportunities__item__logo--2',
                translateX: path5('x'),
                translateY: path5('y'),
                easing: 'linear',
                duration: 30000,
                loop: true,
                direction: 'reverse',
            });
            anime({
                targets: '.nd__opportunities__item__logo--3',
                translateX: path2('x'),
                translateY: path2('y'),
                easing: 'linear',
                duration: 35000,
                loop: true,
            });
            anime({
                targets: '.nd__opportunities__item__socials__fb',
                translateX: path7('x'),
                translateY: path7('y'),
                easing: 'linear',
                duration: 20000,
                loop: true,
            });
            anime({
                targets: '.nd__opportunities__item__socials__tw',
                translateX: path7('x'),
                translateY: path7('y'),
                easing: 'linear',
                duration: 30000,
                direction: 'reverse',
                loop: true,
            });
            anime({
                targets: '.nd__opportunities__item__socials__ig',
                translateX: path7('x'),
                translateY: path7('y'),
                easing: 'linear',
                duration: 30000,
                loop: true,
            });

            anime({
                targets: '.nd__opportunities__item__image--2',
                translateX: path6('x'),
                translateY: path6('y'),
                easing: 'linear',
                duration: 40000,
                direction: 'reverse',
                loop: true,
            });

            anime({
                targets: '.nd__opportunities__item__image--3',
                translateX: path6('x'),
                translateY: path6('y'),
                easing: 'linear',
                duration: 35000,
                loop: true,
            });
        }

        if (window.$('.nd__interleaved').length) {
            let path1 = anime.path('#motion1 path');
            let path2 = anime.path('#motion2 path');
            let path3 = anime.path('#motion3 path');
            let path4 = anime.path('#motion4 path');
            let path5 = anime.path('#motion5 path');
            let path6 = anime.path('#motion6 path');
            let path7 = anime.path('#motion7 path');
            anime({
                targets: '.nd__interleaved__media__plane',
                translateX: path1('x'),
                translateY: path1('y'),
                easing: 'linear',
                duration: 15000,
                loop: true,
            });
            anime({
                targets: '.nd__interleaved__media__maximize__icon1',
                translateX: path2('x'),
                translateY: path2('y'),
                easing: 'linear',
                duration: 40000,
                loop: true,
                direction: 'reverse',
            });
            anime({
                targets: '.nd__interleaved__media__maximize__icon2',
                translateX: path3('x'),
                translateY: path3('y'),
                easing: 'linear',
                duration: 40000,
                loop: true,
            });
            anime({
                targets: '.nd__interleaved__media__maximize__icon3',
                translateX: path4('x'),
                translateY: path4('y'),
                easing: 'linear',
                duration: 35000,
                loop: true,
                direction: 'reverse',
            });
            anime({
                targets: '.nd__interleaved__media__maximize__icon4',
                translateX: path5('x'),
                translateY: path5('y'),
                easing: 'linear',
                duration: 25000,
                loop: true,
                direction: 'reverse',
            });
            anime({
                targets: '.nd__interleaved__media__clients__item-1',
                translateX: path3('x'),
                translateY: path3('y'),
                easing: 'linear',
                duration: 40000,
                loop: true,
                direction: 'reverse',
            });
            anime({
                targets: '.nd__interleaved__media__clients__item-2',
                translateX: path6('x'),
                translateY: path6('y'),
                easing: 'linear',
                duration: 40000,
                loop: true,
            });
            anime({
                targets: '.nd__interleaved__media__clients__item-3',
                translateX: path6('x'),
                translateY: path6('y'),
                easing: 'linear',
                duration: 40000,
                loop: true,
            });
            anime({
                targets: '.nd__interleaved__media__clients__item-4',
                translateX: path5('x'),
                translateY: path5('y'),
                easing: 'linear',
                duration: 30000,
                loop: true,
                direction: 'reverse',
            });
            anime({
                targets: '.nd__interleaved__media__clients__item-5',
                translateX: path2('x'),
                translateY: path2('y'),
                easing: 'linear',
                duration: 35000,
                loop: true,
            });
            anime({
                targets: '.nd__interleaved__media__clients__item-6',
                translateX: path7('x'),
                translateY: path7('y'),
                easing: 'linear',
                duration: 20000,
                loop: true,
            });
            anime({
                targets: '.nd__interleaved__media__clients__item-7',
                translateX: path7('x'),
                translateY: path7('y'),
                easing: 'linear',
                duration: 30000,
                direction: 'reverse',
                loop: true,
            });
            anime({
                targets: '.nd__interleaved__media__attract__img1',
                translateX: path7('x'),
                translateY: path7('y'),
                easing: 'linear',
                duration: 30000,
                loop: true,
            });

            anime({
                targets: '.nd__interleaved__media__attract__img2',
                translateX: path6('x'),
                translateY: path6('y'),
                easing: 'linear',
                duration: 40000,
                direction: 'reverse',
                loop: true,
            });
        }

        if (window.$('.nd__laptop__slider__items').length) {
            var isSafari =
                /Safari/.test(navigator.userAgent) &&
                /Apple Computer/.test(navigator.vendor);
            if (isSafari) {
                $('.nd__laptop__slider').addClass('is-safari');
            }

            $('.nd__laptop__slider__items__inner').slick({
                centerMode: true,
                infinite: true,
                centerPadding: '0',
                slidesToShow: 3,
                speed: 500,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3000,
            });
        }
    });

    window.onload = function() {
        if (window.$('.nd__opportunities__motion__slider').length) {
            let slider = tns({
                container: '.nd__opportunities__motion__slider',
                items: 1,
                slideBy: 1,
                autoplay: true,
                autoplayButton: false,
                autoplayButtonOutput: false,
                nav: false,
                controlsContainer: '.nd__opportunities__motion__controls',
                prevButton: '.nd__opportunities__motion__control--prev',
                nextButton: '.nd__opportunities__motion__control--next',
                edgePadding: 45,
                gutter: 20,
                responsive: {
                    400: {
                        items: 1,
                        edgePadding: 35,
                        gutter: 35,
                    },
                    600: {
                        items: 1,
                        edgePadding: 45,
                        gutter: 45,
                    },
                    760: {
                        items: 1,
                        edgePadding: 45,
                        gutter: 45,
                    },
                    1000: {
                        items: 2,
                        edgePadding: 55,
                        gutter: 20,
                    },
                    1340: {
                        items: 3,
                        edgePadding: 105,
                    },
                    1400: {
                        items: 3,
                        edgePadding: 125,
                    },
                    1800: {
                        items: 4,
                        edgePadding: 130,
                    },
                },
            });
        }

        if (window.$('.nd__clients__motion__slider').length) {
            let slider2 = tns({
                container: '.nd__clients__motion__slider',
                items: 1,
                slideBy: 1,
                autoplay: true,
                autoplayButton: false,
                autoplayButtonOutput: false,
                nav: false,
                navPosition: 'bottom',
                controlsContainer: '.nd__clients__motion__controls',
                prevButton: '.nd__clients__motion__control--prev',
                nextButton: '.nd__clients__motion__control--next',
                edgePadding: 0,
                gutter: 20,
                responsive: {
                    1000: {
                        items: 2,
                        slideBy: 2,
                        nav: true,
                    },
                    1200: {
                        slideBy: 3,
                        items: 3,
                    },
                    1400: {
                        items: 3,
                        slideBy: 3,
                    },
                    2000: {
                        items: 3,
                        slideBy: 3,
                    },
                },
            });
        }
    };

    if (window.$('#nd-menu.nd__menu').length) {
        let ndNavigationBar = window.$('#nd-menu.nd__menu'),
            ndMainHeader = window.$('#main-header'),
            ndTriggerHeight = ndMainHeader.height() + 30;

        function ndStickyHeader() {
            let loc = window.$(window).scrollTop();
            if (loc > ndTriggerHeight) {
                ndNavigationBar.addClass('sticky');
            } else {
                ndNavigationBar.removeClass('sticky');
            }
            if (loc > ndTriggerHeight + 200) {
                ndNavigationBar.addClass('scrolling');
            } else {
                ndNavigationBar.removeClass('scrolling');
            }
        }
        ndStickyHeader();
        window.$(window).on('scroll', function() {
            ndStickyHeader();
        });

        $('.nd__anchor').on('click', function(e) {
            e.preventDefault();
            const href = $(this).attr('data-view');
            $('html, body').animate(
                {
                    scrollTop:
                        $(href).offset().top -
                        $('#nd-menu.nd__menu').outerHeight() +
                        2,
                },
                800
            );
        });
    }

    if (window.$('.nd__pricing__stepper__value').length) {
        const value = $('.nd__pricing__stepper__value__input');
        const add = $('.nd__pricing__stepper__value__add');
        const subtract = $('.nd__pricing__stepper__value__subtract');

        $(value).on('keypress', function(e) {
            if (this.value.length == 3) {
                return false;
            }

            return (
                e.metaKey || // cmd/ctrl
                e.which <= 0 || // arrow keys
                e.which == 8 || // delete key
                /[0-9]/.test(String.fromCharCode(e.which))
            ); // numbers
        });

        $(value).change(function() {
            var min = parseInt($(this).attr('min'));
            if ($(this).val() < min) {
                updateValue(min);
            }
        });

        function updateValue(val) {
            value.val(val);
        }

        add.on('click', function() {
            let newval = value.val();
            newval++;
            updateValue(newval);
        });

        subtract.on('click', function() {
            let newval = value.val();
            if (value.val() <= 3) {
                return;
            }
            newval--;
            updateValue(newval);
        });
    }

    if (window.$('#nd__introslide').length) {
        function updatePosition() {
            const item =
                '#nd__introslide .nd__introslide__masonry__item:nth-of-type(19)';
            const position = parseFloat(
                window
                    .$(item)
                    .position()
                    .top.toFixed(2)
            );
            const height = parseFloat(
                window
                    .$(item)
                    .outerHeight()
                    .toFixed(2)
            );
            const margin = 210;
            const resetAnimPos = position + height + margin;

            document
                .getElementById('nd__introslide__wrapper')
                .style.setProperty('--animend', String(-resetAnimPos + 'px'));
        }

        $(window).on('resize', function() {
            updatePosition();
        });

        updatePosition();
    }

    if ($('.nd__interleaved__media__social').length) {
        function animate() {
            $(
                '.nd__interleaved__media__social__fb, .nd__interleaved__media__social__tw, .nd__interleaved__media__social__ig'
            ).each(function(i) {
                $(this)
                    .delay(i * 300)
                    .animate({ left: 0, opacity: 1 }, 500);
            });

            $('.nd__interleaved__media__social__amount').each(function() {
                $(this)
                    .prop('Counter', 0)
                    .animate(
                        {
                            Counter: $(this).text(),
                        },
                        {
                            duration: 2000,
                            easing: 'swing',
                            step: function(num) {
                                var unit = Math.ceil(num);

                                if (num >= 1000 && $(this).data('short')) {
                                    unit =
                                        (num / 1000)
                                            .toFixed(1)
                                            .replace(/\.0$/, '') + 'K';
                                }

                                $(this).text(unit);
                                return num;
                            },
                        }
                    );
            });
        }

        window.$(window).on('scroll', function() {
            let pos = window.$(window).scrollTop();
            let element = $('#nd__social__trigger');
            let trigger =
                element.offset().top -
                $(window).height() +
                element.height() / 2;

            if (element.hasClass('scroll') && pos > trigger) {
                element.removeClass('scroll');
                animate();
            }
        });
    }
}

if ($('#repform').length) {
    const agency = $('#agency');
    const username = $('#username');

    agency.on('keyup', function() {
        const value = $(this).val();
        username.val(value);
    });
}
